import { useTranslation } from 'react-i18next';

import { ErrorState, FeatureErrorBoundary } from '@nucleus-commerce/admin-kit/errors';
import { PageContent, PageHeader } from '@nucleus-commerce/admin-kit/layout';
import { Skeleton } from '@nucleus-commerce/ui/components/skeleton';

import { DevicesCard } from '../components/devices-card';
import { InstallAppCard } from '../components/install-app-card';
import { ThisDeviceCard } from '../components/this-device-card';
import { usePushSettings } from '../hooks/use-push-settings';
import { useThisDevice } from '../hooks/use-this-device';

function Notifications() {
  const { t } = useTranslation('push');
  const settings = usePushSettings();
  const device = useThisDevice(settings.data?.publicKey);

  return (
    <PageContent width="narrow">
      <PageHeader title={t('page.title')} description={t('page.description')} />
      <div className="flex flex-col gap-6">
        {settings.isError ? (
          <ErrorState error={settings.error} onRetry={() => void settings.refetch()} />
        ) : !settings.data ? (
          <div className="flex flex-col gap-3" data-testid="push-loading">
            <Skeleton className="h-40 w-full" />
            <Skeleton className="h-28 w-full" />
          </div>
        ) : (
          <>
            <ThisDeviceCard
              settings={settings.data}
              device={device.data ?? null}
              syncing={device.isLoading}
            />
            <DevicesCard devices={settings.data.devices} thisDeviceId={device.data?.id ?? null} />
          </>
        )}
        <InstallAppCard />
      </div>
    </PageContent>
  );
}

/** `/account/notifications`: web push on this device, the member's devices, installing the app. */
export function NotificationsPage() {
  return (
    <FeatureErrorBoundary name="push.notifications">
      <Notifications />
    </FeatureErrorBoundary>
  );
}
